import { PapiGallection } from '@wix/da-papi-types';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';

export const isWatchersOnly = (gallery: PapiGallection) =>
  normalizePremiumFolderData(gallery.premiumFolderData).isWatchToAccess;

export const selectPremiumGalleries = (galleries: PapiGallection[]) =>
  galleries.filter(gallery => {
    // Filter out "watchers-only" and keep paid premium folders only.
    const { isPremium, isWatchToAccess } = normalizePremiumFolderData(
      gallery.premiumFolderData
    );
    return isPremium && !isWatchToAccess;
  });
